<template>
  <main class="common-container">
    <section class="page-title flash-title">
      <h2>{{ $t("chart2.dominanceChart") }}</h2>
    </section>

    <section class="explanation-container center">
      <img :src="explainImg" alt="" />
    </section>

    <section class="explanation-container center">
      <ul class="color-circle">
        <li class="color-circle__item">
          <p v-html="$t('domiExp.content1.descText1')"></p>
        </li>
        <li class="color-circle__item">
          <p v-html="$t('domiExp.content1.descText2')"></p>
        </li>
        <li class="color-circle__item">
          <p v-html="$t('domiExp.content1.descText3')"></p>
        </li>
        <li class="color-circle__item">
          <p v-html="$t('coinExp.content1.descText4')"></p>
        </li>
      </ul>
    </section>
  </main>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from "vue";
import { useResolutionStore } from "@/store/useResolution";
import dominanceImg from "@/assets/images/pages/explanation/dominance/dominance.png";
import dominanceMImg from "@/assets/images/pages/explanation/dominance/dominance-m.png";

const resolutionStore = useResolutionStore();
const isMobile = computed(() => resolutionStore.isMobile);
// isMobile 값이 변경될 때 자동으로 업데이트됨
const explainImg = computed(() =>
  isMobile.value ? dominanceMImg : dominanceImg
);

const updateWindowSize = () => {
  resolutionStore.setSize({ width: window.innerWidth });
};

onMounted(() => {
  window.addEventListener("resize", updateWindowSize);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWindowSize);
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/explanation/common_explanation.scss";

.common-container.insert-content {
  overflow-y: unset !important;
  @media (max-width: 768px) {
    overflow-y: auto !important;
  }
}
</style>
